import { render, staticRenderFns } from "./create-student-page.html?vue&type=template&id=4cb1d229&"
import script from "./create-student-page.ts?vue&type=script&lang=ts&"
export * from "./create-student-page.ts?vue&type=script&lang=ts&"
import style0 from "./create-student-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports